import { ICoreContext } from '@msdyn365-commerce/core';
import { useState } from 'react';
import { getPageGenderFromUrl } from '../../../shared/services/gender-cookie-service/gender-cookie-service';
import { useGenderCookieValue } from '../../../shared/services/gender-cookie-service/hooks/use-gender-cookie-value';
import { Gender } from '../../../shared/services/gender-cookie-service/gender-cookie-service.types';

export const useRecommendationGender = (context: ICoreContext, isEnabled: boolean): Gender | undefined => {
    const [pageGender] = useState(() => (isEnabled ? getPageGenderFromUrl(context.request) : undefined));
    const cookieGender = useGenderCookieValue(context.request);

    return isEnabled ? (pageGender ?? cookieGender) : undefined;
};
